import React, { useContext, useState } from "react"
import { firestore } from "../firebase/firebase"

const ServiceContext = React.createContext()

export function useService() {
    return useContext(ServiceContext);
}

export function ServiceProvider({ children }) {

    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    function getServices() {
        //Check if customers exist on local storage
        if (services.length <= 0) {

            //Query customer collection for all docs
            firestore.collection('services').orderBy('id').get()
                .then(querySnapshot => {
                    const serviceResponse = querySnapshot.docs.map((doc) => {
                        return {
                            ...doc.data(),
                            'docId': doc.id,
                        }
                    })

                    setServices(serviceResponse);
                    setLoading(false);
                    //sessionStorage.setItem("serviceData", JSON.stringify(serviceResponse));
                },
                    error => {
                        setLoading(false);
                        setError(error.message);
                        console.log(error.message);
                    }
                )
        }
        else
            setLoading(false);

        //console.log("Services exist on local storage")
    }


    const value = {
        services,
        loading,
        error,
        getServices,
    }

    return (
        <ServiceContext.Provider value={value}>
            {children}
        </ServiceContext.Provider>
    )
}